var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSliderArrow = function SvgIconSliderArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 27.5,
    transform: "matrix(1 0 0 -1 27.999 28)",
    fill: "#fff",
    stroke: "#14643C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.999 34 6-6-6-6",
    stroke: "#14643C",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
};
export default SvgIconSliderArrow;